import { Header, Link, Text } from '@inato/ui';

import { ErrorPagesLayout } from '@components/AppLayout/ErrorPagesLayout';
import { useEnvironmentService } from '../../EnvironmentContext';
import { CONTACT_US_EMAIL } from '../../shared/constants/emails';

export const SomethingWentWrong = () => {
  const environmentService = useEnvironmentService();
  const apiUrl = environmentService.get('PUBLIC_BASE_API_URL');
  return (
    <ErrorPagesLayout>
      <div className="mt-l desktop:mt-xl m-auto flex max-w-[640px] flex-col">
        <Header className="mb-xl" tag="h1" size="5xl">
          Something went wrong
        </Header>
        <Text className="mb-l" asSpan size="l">
          We can’t connect you to Inato.
        </Text>
        <Text asSpan size="l">
          To troubleshoot, here is what you can try:
        </Text>
        <ul className="m-zero pl-l text-l leading-l">
          <li>
            <Text size="l" className="font-semibold">
              Wait and try again in a couple of minutes
            </Text>
            Our service might be temporarily unavailable. In that case, our
            engineers have been automatically notified and are working on a fix.
          </li>
          <li>
            <Text size="l" className="font-semibold">
              Contact your network administrators
            </Text>
            If the problem persists, it is likely that our site is blocked by
            your network. To get access, contact your network administrators and
            ask them to whitelist “{apiUrl}”.
          </li>
        </ul>
        <Text className="mt-l" asSpan size="l">
          To get, additional help, email us at{' '}
          <Link href={`mailto:${CONTACT_US_EMAIL}`}>{CONTACT_US_EMAIL}</Link>
        </Text>
      </div>
    </ErrorPagesLayout>
  );
};
